export default "__VITE_ASSET__BOIcZSqv__"